import type {
  TTransaction,
  TTransactionServer,
  TTransactionResponse,
  TTransactionResponseServer,
} from '../../store/types';

export const transactionsItemAdapter = (item: TTransactionServer): TTransaction => ({
  id: item.id,
  created: item.created,
  shopId: item.shop_id,
  type: item.type,
  status: item.status,
  currency: item.currency,
  amount: item.amount,
  balanceBefore: item.balance_before,
  balanceAfter: item.balance_after,
  requestId: item.request_id,
  requestAmount: item.request_amount,
  paidAmount: item.paid_amount,
  methodId: item.method_id,
  methodName: item.method_name,
  paymentSystemName: item.payment_system_name,
});

export const transactionsAdapter = ({ count, items }: TTransactionResponseServer): TTransactionResponse => ({
  count,
  items: items.map(transactionsItemAdapter),
});
